import { css } from '@emotion/react';
import React from 'react';

export const HeaderDivider: React.FC = () => {
  const headerDividerCss = {
    self: [
      css({
        borderBottom: '1px solid var(--ion-background-color-step-150)',
      }),
    ],
  };

  return <div css={headerDividerCss.self}></div>;
};
